import WordMonthDate from "../DateChanged/WordMonthDate/WordMonthDate";
import MoneyMask from "../MoneyMask/MoneyMask";

function isDateString(value) {
    const regex = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z)?$/;

    if (!regex.test(value)) {
        return false; // A string não corresponde ao formato esperado
    }

    const date = new Date(value);
    return !isNaN(date.getTime());
}

function formatAttribute(value, mask, isDetail, minimumFractionDigits) {
    if ((value === null || value === 0) && !isDetail) {
        return '- - -'
    }

    if (value === null || value === 0) {
        return value
    }

    if (!isDateString(value)) {
        if (mask === 'money') {
            return MoneyMask.validateMoneyMask(value);
        }

        if (minimumFractionDigits) {
            return validateMaskFraction(value, minimumFractionDigits)
        }

        return value.toString();
    }
    return WordMonthDate.dateFormat(value)
}


function validateMaskFraction(value, minimumFractionDigits) {
    if (/[a-zA-Z]/.test(value)) {
        return value;
    }

    if (value === 0) return value;

    const formattedValue = value.toLocaleString('pt-BR', {
        minimumFractionDigits: minimumFractionDigits,
    }).replace(',', '.');

    return formattedValue;
}

export default { isDateString, formatAttribute };
